import React, { useEffect, useRef, useState } from "react";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import Float from "../../ui/Float";
import Button from "../../ui/Button";
import { kbdEvent } from "../../utils/Utils";
import { KBD } from "../../utils/Keybindings";
import Space from "../../ui/Space";
import Picker, { drawPicker } from "../../popovers/Picker";
import { listen } from "../../hooks/Listener";
import Select from "../../ui/Select";


export default function Stores(props) {

    const { controller = "", loading = false, setLoading = () => { }, state = "", setState = () => { }, session = {}, setSession = () => { }, route = "", continueToBMO = () => { }, logout = () => { } } = props;

    const ref = useRef();
    const current = session.available_corps.find(item => item.id === session.corp_id);
    const [store, setStore] = useState(current.id);
    const name = session.available_corps.find(item => item.id === store);

    const stores = session.available_corps.filter(item => item.can_bmo).map(item => {
        return {
            value: item.id,
            label: item.name
        }
    })

    useEffect(() => {
        if (ref?.current) {
            ref.current.focus();
        }

        let nm = session.available_corps.find(item => item.id === store);
        const actions = [
            { key: KBD.PAGE_DOWN, action: (e) => { continueToBMO(store, nm.name) } },
            { key: KBD.ESCAPE, action: (e) => { logout() } },
        ];
        const cleanup = listen(controller, route, actions, null, [KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ESCAPE, KBD.ENTER], [], []);
        return cleanup;
    }, [session, current, store]);

    return (
        <div>
            <Float>
                <Label style={{ "textAlign": "left" }} width={150}>Select a store </Label>
            </Float>
            <div className="shim" /><div className="shim" />
            <Picker controller={controller} callback={(e) => {
                if (e) {
                    let nm = session.available_corps.find(item => item.id === store);
                    setStore(e)
                    continueToBMO(e, nm.name)
                }
            }} width={250} popup={(ref)} options={stores} value={name.id} hide_header route={route} />
            <div className="shim" /> <div className="shim" /> <div className="shim" />
            <Float>
                <div></div>
                <Space>
                    <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)} >Logout</Button>
                    <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary">Continue</Button>
                </Space>
            </Float>
        </div>
    )
}